import { useRecoilState } from "recoil";
import { loadingCauc } from "../atom";

const useLoadingCaucState = () => {
    return useRecoilState(loadingCauc);
};

export default useLoadingCaucState;